import { render } from "./Variables.vue?vue&type=template&id=a961e416"
import script from "./Variables.vue?vue&type=script&lang=js"
export * from "./Variables.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__